<template>
  <div class="jsf">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">JSF(Jein SAP Interface Framework)</h3>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <v-img contain :src="require('@/assets/img_sub_prod_jsf.png')" max-height="432"></v-img>

          <h5 class="text-h6 text-md-h5 font-weight-bold mt-10">JSF 소개</h5>
          <p>SAP ERP 시스템과 연동이 필요한 Web Application 개발 시 손쉽게 구현이 가능한 프레임워크</p>

          <h5 class="text-h6 text-md-h5 font-weight-bold mt-10">JSF 아키텍처</h5>
          <p>서버 개발 없이 클라이언트 (UI) 개발만으로 SAP 연계 데이터 호출 가능.<br>UI 개발자는 SAP 연계에 필요한 데이터를 표준 데이터 모델 (JSON)로 생성하여 어플리케이션에서 직접 사용</p>

          <h5 class="text-h6 text-md-h5 font-weight-bold mt-10">JSF 특징</h5>
          <ul class="jsf-list mt-2">
            <li>
              <p class="ic-container"><v-icon large color="white">mdi-calendar-clock</v-icon></p>
              <dl class="dl-type02">
                <dt class="text-subtitle-1 text-md-h6 font-weight-bold">개발기간 단축 및 비용 감소</dt>
                <dd class="mt-1">
                  <p class="mb-1">높은 이식성 (Any Framework & Any Web Application Server)</p>
                  <ul class="list-type02">
                    <li>모든 Framework (Spring, Spring Boot, Anyframe, 전자정부프레임워크)와 연동</li>
                    <li>J2EE 기반 Web Application Server 지원<br>(Apache Tomcat, Redhat JBoss, Tmax JEUS, Oracle WebLogic, IBM Web Sphere, SAP NetWeaver 등)</li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li>
              <p class="ic-container"><v-icon large color="white">mdi-shield-lock</v-icon></p>
              <dl class="dl-type02">
                <dt class="text-subtitle-1 text-md-h6 font-weight-bold">안전성 및 신뢰성</dt>
                <dd class="mt-1">
                  <p class="mb-1">개발 생산성 증대 및 품질 향상 효과</p>
                  <ul class="list-type02">
                    <li>개발자 간의 개발 편차를 줄이고, SAP 연계에 대한 표준화 제공
                      <ul class="list-type03">
                        <li>표준화 된 Data Format 및 Service 사용</li>
                        <li>JSON 기반 RESTful 통신 지원</li>
                      </ul>
                    </li>
                    <li>RFC Function 및 OData Service 에러 발생을 최소화
                      <ul class="list-type03">
                        <li>메타 데이터 조회</li>
                        <li>데이터 타입 자동 변환</li>
                      </ul>
                    </li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li>
              <p class="ic-container"><v-icon large color="white">mdi-chart-box</v-icon></p>
              <dl class="dl-type02">
                <dt class="text-subtitle-1 text-md-h6 font-weight-bold">운영 리스크 최소화</dt>
                <dd class="mt-1">
                  <p class="mb-1">운영 편리성 및 데이터 보안</p>
                  <ul class="list-type02">
                    <li>SAP 연결 설정 실시간 Switching</li>
                    <li>SAP 시스템 랜드스케이프별 Log 구성 (시스템 오버헤드 감소 및 연결 시스템별 Log 분리 관리)</li>
                    <li>송수신 데이터 암복호화 처리 (선택)</li>
                  </ul>
                </dd>
              </dl>
            </li>
          </ul>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'jsf',
  data() {
    return {
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".jsf .sub-body-title", {
      scrollTrigger: {
        trigger: ".jsf .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".jsf .sub-body-content", {
      scrollTrigger: {
        trigger: ".jsf .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>